module.exports = __webpack_public_path__ + "img/ee1bba5.jpg";